export default __webpack_public_path__ + "static/256-9c16264cdfd066187ad8aab867b2f55a.gif";